module.exports = __webpack_public_path__ + "static/img/app_preview-sv029.7e12f47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/appdownlord/app_preview-sv029.jpg
// module id = BiFr
// module chunks = 0